import PersonAiProfile from './PersonAiProfile';
export default PersonAiProfile;
